// src/components/sections/TrustStrip.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaAward, FaUserMd, FaHeartbeat, FaStar, FaCertificate, FaUsers } from 'react-icons/fa';

const TrustStrip = () => {
    const stats = [
        { icon: <FaAward />, value: '25+', label: 'Years of Excellence', color: '#FFD700' },
        { icon: <FaUsers />, value: '50,000+', label: 'Happy Patients', color: '#20B2AA' },
        { icon: <FaUserMd />, value: '80+', label: 'Specialist Doctors', color: '#87CEEB' },
        { icon: <FaHeartbeat />, value: '15,000+', label: 'Successful Deliveries', color: '#FF7F50' },
        { icon: <FaStar />, value: '4.9/5', label: 'Patient Rating', color: '#FFD700' },
        { icon: <FaCertificate />, value: 'JCI', label: 'Accredited', color: '#20B2AA' },
    ];

    return (
        <section style={{ backgroundColor: 'var(--light-bg)', padding: '40px 0' }}>
            <Container>
                <Row className="g-4">
                    {stats.map((stat, index) => (
                        <Col md={4} lg={2} key={index}>
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                                className="text-center p-3 hover-lift healthcare-card"
                            >
                                <div
                                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: '70px',
                                        height: '70px',
                                        backgroundColor: `${stat.color}20`,
                                        color: stat.color,
                                        fontSize: '1.8rem'
                                    }}
                                >
                                    {stat.icon}
                                </div>
                                <h3 className="fw-bold mb-2">{stat.value}</h3>
                                <p className="mb-0" style={{ color: '#666', fontSize: '0.9rem' }}>{stat.label}</p>
                            </motion.div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default TrustStrip;